import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {
    ISchedaCosto
} from "../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/ISchedaCosto";


const useApiUpdateSchedaCosto = (): UseMutationResult<ISchedaCosto, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const {put} = useApiCalls()
    const {selectedCompany} = useAuth()

    const doUpdate = async (
        pk: number,
        data: any): Promise<ISchedaCosto> => {
        try {
            const response = await put(`/api/company/${selectedCompany?.company_token}/tannery_production/schede_costo/schede_costo/${pk}/`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    return useMutation<ISchedaCosto, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(id, data);
        },
    });
};

export default useApiUpdateSchedaCosto;
